module.exports = __webpack_public_path__ + "img/flag-de.b5199704.svg";